<div [ngClass]="styleClass">
    <div class="sera-multiselect-label-container">
        <label for="{{ inputId }}">{{ label }}</label>
    </div>
    <p-multiSelect
        appendTo="body"
        [attr.sera-read-only]="readOnly ? '' : null"
        [style]="style"
        [inputId]="inputId"
        [(ngModel)]="value"
        [required]="required"
        [disabled]="isDisabled"
        [readonly]="readOnly"
        [options]="options"
        [optionLabel]="'name'"
        [optionValue]="'key'"
        [maxSelectedLabels]="30"
        [optionDisabled]="'optionDisabled'"
        [virtualScroll]="virtualScroll"
        [virtualScrollItemSize]="itemSize"
        [filter]="filter"
        [tooltip]="tooltip"
        [showClear]="showClear || !readOnly"
        (onClear)="clearSelection.emit(value)"
        (onChange)="selectionChanged.emit(value)"
        (onPanelHide)="closeSelection.emit(value)"
        (onPanelShow)="onPanelShow()"
        [dropdownIcon]="readOnly ? 'none' : 'pi pi-chevron-down'"
        [placeholder]="placeholder">
    </p-multiSelect>
</div>
